// extracted by mini-css-extract-plugin
export var activeFilterButton = "_s7-c";
export var backButton = "_s7-4";
export var backIcon = "_s7-5";
export var chevronShortcut = "_s7-6";
export var container = "_s7-1";
export var editor = "_s7-8";
export var editorWrapper = "_s7-7";
export var prefix = "_s7-2";
export var searchIcon = "_s7-3";
export var suffix = "_s7-9";
export var suffixContent = "_s7-a";
export var suffixText = "_s7-b";
export var wrapper = "_s7-0";